import { useCallback, useState } from "react"

export const useLoading = (initialState = false) => {
    const [isLoading, setIsLoading] = useState(initialState);

    const start = useCallback(() => setIsLoading(true), []);

    const stop = useCallback(() => setIsLoading(false), []);

    const toggle = useCallback(() => setIsLoading(state => !state), []);

    return { value: isLoading, start, stop, toggle };
}
